import { render, staticRenderFns } from "./AddIncome.vue?vue&type=template&id=1deb0397&scoped=true"
import script from "./AddIncome.vue?vue&type=script&lang=js"
export * from "./AddIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deb0397",
  null
  
)

export default component.exports